export default __webpack_public_path__ + "static/media/birds.ae2d9f47.png";